import React from "react";
import { Col } from "antd";
import { useTranslation } from "react-i18next";
import { Widget } from "../../../../Atomics/Widget";
import { isEmpty } from "../../../../../../utils/hooks/isEmpty";
import { LeftIncidentsWidgetsSingleClassComponent } from "./LeftIncidentsWidgetsSingleClassComponent";
import { LeftIncidentsWidgetsMultipleClassComponent } from "./LeftIncidentsWidgetsMultipleClassComponent";
import Theme from "../../../../../../styles/Theme/Theme";

export const LeftIncidentsWidgetsOverlay = ({ mapPois, classes }) => {
  const { t } = useTranslation();

  return (
    <>
      {mapPois ?
        <Col span={24} className="overlay-widget">
          <Widget
            data={{
              background: "white",
              title: t("Incidents Number"),
              icon: null,
              activeShadow: true,
              charts: [
                {
                  chartType: "simpleDonutChartApex",
                  height: "170px",
                  data: mapPois && !isEmpty(mapPois) ? serializeNumberOfIncidents(mapPois, t) : []
                },
              ],
            }}
          />
        </Col>
        : null}

      {mapPois ?
        <>
          {/* {classes?.length > 1 ? */}
            <LeftIncidentsWidgetsMultipleClassComponent items={mapPois} />
            {/* :
            classes?.length === 1 &&
            <LeftIncidentsWidgetsSingleClassComponent items={mapPois} classes={classes} />
          } */}
        </>
        : null}
    </>
  );
};

const serializeNumberOfIncidents = (data, t) => {
  const priorities = ["1 - High", "2 - Medium High", "3 - Medium", "4 - Medium Low", "5 - Low"];
  const colors = [Theme.color['critical-base'], Theme.color['high-base'], Theme.color['medium-base'], Theme.color['low-base'], Theme.color['info-base']];
  const groupedByPriority = groupBy(data, ({ priority }) => priority);
  const series = [];
  var hasValue = false;
  var total = 0;

  priorities.map((priority, index) => {
    const value = groupedByPriority[priority] || [];
    total += value.length;
    if (hasValue === false && value.length > 0) hasValue = true;

    series.push({
      name: t(priority.split(' - ')[1]),
      value: value.length ?? 0,
      color: colors[index]
    });
  });

  return {
    "series": hasValue ? series : null,
    "categories": null,
    "tooltip": null,
    "markerSize": 3,
    "unit": "",
    // "columnWidth": 20,
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "categorias",
    "total": total,
    "noDecimal": true,
    "customScale": 0.8,
    dataLabelsOffset: 42,
    sideLegend: true,
    disableToolbar: true,
    disableDataLabels: true,
    centerVerticalLegend: true,
    showNameTotal: true
  };
};

const groupBy = (array, keyGetter) => {
  return array.reduce((result, currentItem) => {
    const groupKey = keyGetter(currentItem);
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    result[groupKey].push(currentItem);
    return result;
  }, {});
};